/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as SettingsRouteImport } from "./routes/settings"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as SettingsIndexRouteImport } from "./routes/settings/index"
import { Route as SettingsLiveConfigurationsRouteImport } from "./routes/settings/liveConfigurations"
import { Route as SettingsGeneralRouteImport } from "./routes/settings/general"
import { Route as SettingsAdminRouteImport } from "./routes/settings/admin"

const SettingsRoute = SettingsRouteImport.update({
  id: "/settings",
  path: "/settings",
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsLiveConfigurationsRoute =
  SettingsLiveConfigurationsRouteImport.update({
    id: "/liveConfigurations",
    path: "/liveConfigurations",
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsGeneralRoute = SettingsGeneralRouteImport.update({
  id: "/general",
  path: "/general",
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsAdminRoute = SettingsAdminRouteImport.update({
  id: "/admin",
  path: "/admin",
  getParentRoute: () => SettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/settings": typeof SettingsRouteWithChildren
  "/settings/admin": typeof SettingsAdminRoute
  "/settings/general": typeof SettingsGeneralRoute
  "/settings/liveConfigurations": typeof SettingsLiveConfigurationsRoute
  "/settings/": typeof SettingsIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/settings/admin": typeof SettingsAdminRoute
  "/settings/general": typeof SettingsGeneralRoute
  "/settings/liveConfigurations": typeof SettingsLiveConfigurationsRoute
  "/settings": typeof SettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/settings": typeof SettingsRouteWithChildren
  "/settings/admin": typeof SettingsAdminRoute
  "/settings/general": typeof SettingsGeneralRoute
  "/settings/liveConfigurations": typeof SettingsLiveConfigurationsRoute
  "/settings/": typeof SettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/settings"
    | "/settings/admin"
    | "/settings/general"
    | "/settings/liveConfigurations"
    | "/settings/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/settings/admin"
    | "/settings/general"
    | "/settings/liveConfigurations"
    | "/settings"
  id:
    | "__root__"
    | "/"
    | "/settings"
    | "/settings/admin"
    | "/settings/general"
    | "/settings/liveConfigurations"
    | "/settings/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SettingsRoute: typeof SettingsRouteWithChildren
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/settings": {
      id: "/settings"
      path: "/settings"
      fullPath: "/settings"
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/settings/": {
      id: "/settings/"
      path: "/"
      fullPath: "/settings/"
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    "/settings/liveConfigurations": {
      id: "/settings/liveConfigurations"
      path: "/liveConfigurations"
      fullPath: "/settings/liveConfigurations"
      preLoaderRoute: typeof SettingsLiveConfigurationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    "/settings/general": {
      id: "/settings/general"
      path: "/general"
      fullPath: "/settings/general"
      preLoaderRoute: typeof SettingsGeneralRouteImport
      parentRoute: typeof SettingsRoute
    }
    "/settings/admin": {
      id: "/settings/admin"
      path: "/admin"
      fullPath: "/settings/admin"
      preLoaderRoute: typeof SettingsAdminRouteImport
      parentRoute: typeof SettingsRoute
    }
  }
}

interface SettingsRouteChildren {
  SettingsAdminRoute: typeof SettingsAdminRoute
  SettingsGeneralRoute: typeof SettingsGeneralRoute
  SettingsLiveConfigurationsRoute: typeof SettingsLiveConfigurationsRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsAdminRoute: SettingsAdminRoute,
  SettingsGeneralRoute: SettingsGeneralRoute,
  SettingsLiveConfigurationsRoute: SettingsLiveConfigurationsRoute,
  SettingsIndexRoute: SettingsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SettingsRoute: SettingsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
